module.exports = __webpack_public_path__ + "img/arrow-left.266eef6f.svg";